var map = {
	"./ally.png": "07c1",
	"./dauntless.png": "cbdd",
	"./diplomat.png": "3cc6",
	"./enemy.png": "a0e1",
	"./roleplay.png": "a8d0",
	"./sleepless.png": "68ed",
	"./special_anonymous.png": "c0e0",
	"./special_arcade.png": "c211",
	"./special_battleRoyale.png": "bba9",
	"./special_dark.png": "e0c4",
	"./special_fog.png": "cae2",
	"./special_freeForAll.png": "dc66",
	"./special_homeStar.png": "1aae",
	"./special_homeStarElimination.png": "ae70",
	"./special_kingOfTheHill.png": "06d4",
	"./special_orbital.png": "d1e1",
	"./special_tinyGalaxy.png": "44ec",
	"./special_ultraDark.png": "f0ce",
	"./strategist.png": "9bca",
	"./victor32.png": "96c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8779";